<template>
  <v-app>
    <Header v-if="$store.state.isLogged && isDefaultLayout" class="header-bg" />
    <!-- v-if="$store.state.isLogged" -->
    <Menu v-if="$store.state.navMenu && isDefaultLayout" />
    <!-- <Menu v-if="$store.state.isLogged" /> -->
    <Content />
    <Fotter v-if="$store.state.isLogged && isDefaultLayout" />
  </v-app>
</template>

<script>
import Header from "@/components/core/Header";
import Fotter from "@/components/core/Fotter";
import Menu from "@/components/core/Menu";
import Content from "@/components/core/Content";
import AustinHairlineRoman from "./assets/FONT-DEJUDOM/AustinHairline-Roman.otf";

export default {
  name: "App",
  components: {
    Header,
    Menu,
    Content,
    Fotter,
  },
  mounted() {
    this.$store.dispatch({ type: "restoreLogin" });
  },
  computed: {
    isDefaultLayout() {
      // ถ้าไม่กำหนด meta => ถือว่า default
      return this.$route.meta.layout !== "blank";
    }
  }
};
</script>

<style>
/* @font-face {
  font-family: "AustinHairline-Roman";
  src: local("AustinHairline-Roman"),
    url("./assets/FONT-DEJUDOM/AustinHairline-Roman.otf") format("truetype");
} */
/* @font-face {
  font-family: "EscrowCond-Roman";
  src: local("EscrowCond-Roman"),
    url("./assets/FONT-DEJUDOM/Font\ Bureau\ -\ EscrowCond-Roman.otf")
      format("truetype");
} */
/* .v-application {
  font-family: "EscrowCond-Roman";
} */
.signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #0730e9, #0730e9);
  background-origin: border-box;
  background-clip: content-box, border-box;
}

.bg-colorth {
  background-color: #595959;
  color: red;
}

.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>.tabletextwhite {
  color: #ffffff;
}

.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>.texttablehcenter {
  color: #ffffff;
  text-align-last: center;
}

.theme--light.v-data-table>.v-data-table__wrapper>table>thead>th>.tabletheader {
  background-color: #595959 !important;
}

.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr:last-child>th {
  background-color: #595959;
  color: white;
}

.hintcolorred .v-messages__message {
  color: red !important;
}

.v-main__wrap {
  background-color: #fafafa !important;
}

.v-app-bar {
  background-color: #fafafa !important;
}

.v-tabs .v-slide-group__content {
  background-color: #FAFAFA !important;
}

.small-switch .v-label {
  font-size: 14px;
}

.small-switch .v-input--selection-controls__input {
  transform: scale(0.7);
}
</style>
